import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { LegacyPortalAccountService } from "@spwn-portal/grpc";

import { consumeStartggState } from "./startggAuthorize";
import { startggConfig } from "./startggConfig";
import { useStartggLink } from "./useStartggLink";
import { useConnectClient } from "../../utility/connectWeb";

type Phase = "processing" | "done" | "error";

/**
 * start.gg OAuth の callback ルート（redirect_uri = /account/startgg/callback）。
 * SPA が ?code&state を受け、state を照合してから ExchangeStartggCode RPC を呼ぶ。
 * 得られた start.gg user.id を Firestore に保存して連携完了とする。
 */
export const StartggCallback: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const client = useConnectClient(LegacyPortalAccountService);
  const { save } = useStartggLink();
  const [phase, setPhase] = useState<Phase>("processing");
  const [message, setMessage] = useState("start.gg と連携しています…");
  // authorization code は1回限り・短命。StrictMode の二重実行で2回交換して失敗するのを防ぐ。
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) {
      return;
    }
    handledRef.current = true;

    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const state = params.get("state");

    if (!code) {
      setPhase("error");
      setMessage("認可コードが見つかりません。");
      return;
    }
    if (!consumeStartggState(state)) {
      setPhase("error");
      setMessage("state が一致しません。最初からやり直してください。");
      return;
    }

    void (async () => {
      try {
        const res = await client.exchangeStartggCode({
          code,
          redirectUri: startggConfig.redirectUri,
        });
        await save({
          userId: res.startggUserId,
          username: res.startggUsername,
          linkedAt: Date.now(),
        });
        setPhase("done");
        setMessage(`連携しました: ${res.startggUsername}`);
        setTimeout(() => history.replace("/evoj/entry"), 800);
      } catch (e) {
        console.error(e);
        setPhase("error");
        setMessage("連携に失敗しました。");
      }
    })();
  }, [client, history, location.search, save]);

  return (
    <div style={{ padding: 24, maxWidth: 640, margin: "0 auto" }}>
      <h1>start.gg 連携</h1>
      <p>{message}</p>
      {phase === "error" && (
        <button type="button" onClick={() => history.replace("/evoj/entry")}>
          戻る
        </button>
      )}
    </div>
  );
};
